export default "__VITE_ASSET__BmRAD8za__"